import React from 'react';
import ContactInfo from '../components/ContactInfo';
import CustomerServiceInfo from '../components/CustomerServiceInfo';
import IntegrationsInfo from '../components/Integrations';
import PaymentInfo from '../components/PaymentInfo';

const STATUS_LABEL = {
    INCOMPLETE: 'Incomplete',
    FINISHED: 'Finished',
    OPTIONAL: 'Optional'
};

export const getSections = ({ store, closeCollapse }) => {
    const { isCustomerInfoValid, isKlicklyInfoValid, isManual, paymentMethod } = store.accountsStore;

    const sections = [
        {
            itemKey: 'customer-service',
            title: 'How will customers contact you?',
            content: <CustomerServiceInfo closeCollapse={() => closeCollapse('customer-service')} />,
            status: isCustomerInfoValid ? STATUS_LABEL.FINISHED : STATUS_LABEL.INCOMPLETE
        },
        {
            itemKey: 'payment-info',
            title: 'How will Klickly charge you?',
            content: <PaymentInfo closeCollapse={() => closeCollapse('payment-info')} />,
            status: paymentMethod && paymentMethod.isVerified ? STATUS_LABEL.FINISHED : STATUS_LABEL.INCOMPLETE
        },
        {
            itemKey: 'contact-info',
            title: 'How will Klickly contact you?',
            content: <ContactInfo closeCollapse={() => closeCollapse('contact-info')} />,
            status: isKlicklyInfoValid ? STATUS_LABEL.FINISHED : STATUS_LABEL.INCOMPLETE
        }
    ];

    // Integrations section has content only for Manual stores
    if (isManual) {
        sections.push({
            itemKey: 'integrations-info',
            title: 'Integrations',
            content: <IntegrationsInfo closeCollapse={() => closeCollapse('integrations-info')} />,
            status: STATUS_LABEL.OPTIONAL
        });
    }

    return sections;
};
